export class CountryRegions {
    public CA: {
        AB: string;
        BC: string;
        MB: string;
        NB: string;
        NL: string;
        NS: string;
        NT: string;
        NU: string;
        ON: string;
        PE: string;
        QC: string;
        SK: string;
        YT: string;
    };
    public CO: {
        AMA: string;
        ANT: string;
        ARA: string;
        ATL: string;
        BOL: string;
        BOY: string;
        CAL: string;
        CAQ: string;
        CAS: string;
        CAU: string;
        CES: string;
        CHO: string;
        COR: string;
        CUN: string;
        DC: string;
        GUA: string;
        GUV: string;
        HUI: string;
        LAG: string;
        MAG: string;
        MET: string;
        NAR: string;
        NSA: string;
        PUT: string;
        QUI: string;
        RIS: string;
        SAN: string;
        SAP: string;
        SUC: string;
        TOL: string;
        VAC: string;
        VAU: string;
        VID: string;
    };
    public MX: {
        AGU: string;
        BCN: string;
        BCS: string;
        CAM: string;
        CHH: string;
        CHP: string;
        CMX: string;
        COA: string;
        COL: string;
        DUR: string;
        GRO: string;
        GUA: string;
        HID: string;
        JAL: string;
        MEX: string;
        MIC: string;
        MOR: string;
        NAY: string;
        NLE: string;
        OAX: string;
        PUE: string;
        QUE: string;
        ROO: string;
        SIN: string;
        SLP: string;
        SON: string;
        TAB: string;
        TAM: string;
        TLA: string;
        VER: string;
        YUC: string;
        ZAC: string;
    };
    public US: {
        AK: string;
        AL: string;
        AR: string;
        AS: string;
        AZ: string;
        CA: string;
        CO: string;
        CT: string;
        DC: string;
        DE: string;
        FL: string;
        GA: string;
        GU: string;
        HI: string;
        IA: string;
        ID: string;
        IL: string;
        IN: string;
        KS: string;
        KY: string;
        LA: string;
        MA: string;
        MD: string;
        ME: string;
        MI: string;
        MN: string;
        MO: string;
        MP: string;
        MS: string;
        MT: string;
        NC: string;
        ND: string;
        NE: string;
        NH: string;
        NJ: string;
        NM: string;
        NV: string;
        OH: string;
        OK: string;
        OR: string;
        PA: string;
        PR: string;
        RI: string;
        SC: string;
        SD: string;
        TN: string;
        TX: string;
        UT: string;
        VA: string;
        VI: string;
        VT: string;
        WA: string;
        WI: string;
        WV: string;
        WY: string;
    };
}


// WEBPACK FOOTER //
// ./src/resources/CountryRegions.ts